export const navLinks = [
  { id: "focus", label: "焦点盘点" },
  { id: "events", label: "热门事件" },
  { id: "timeline", label: "大瓜时间线" },
  { id: "categories", label: "主题分类" },
  { id: "ranking", label: "热度榜" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于我们" },
];

export const tickerItems = [
  "古装剧番位风波进入复盘阶段",
  "音乐节门票秒空，退票规则同步更新",
  "旅行真人秀剪辑争议持续被讨论",
  "演唱会档期调整方案已公布",
  "限定周边设计翻车事件完整复盘上线",
  "短剧出海分账模式观察更新",
];